import React from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { HotelCenterReconReportGrid } from '@bingads-webui-campaign-react/hotel-center-recon-report-grid';
import getStyles from './style/index';

const hotelCenterI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
class HotelCenterProcessedReconReport extends React.PureComponent {
  render() {
    const { classes, i18n, perfMarker } = this.props;
    const mergedI18n = mergeI18n(hotelCenterI18n, i18n);
    return (
      <React.Fragment>
        <section className={`${classes.marginContainer} intelligence-processed-recon-container`}>
          <p>{i18n.getString(_TL_('The Processed Reconciliation Report allow you to view which stayed booking in the report.'))}</p>
          <HotelCenterReconReportGrid i18n={mergedI18n} perfMarker={perfMarker} reportType="ProcessedReconciliationReport" />
        </section>
      </React.Fragment>
    );
  }
}

HotelCenterProcessedReconReport.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
};

const Wrapped = withDefaultStyles(HotelCenterProcessedReconReport, getStyles);

export { Wrapped as HotelCenterProcessedReconReport };
